import { render, staticRenderFns } from "./EditModuleForm.vue?vue&type=template&id=fed8007c"
import script from "./EditModuleForm.vue?vue&type=script&lang=js"
export * from "./EditModuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports